import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { AppShell, Topbar, useShellDrawerActions } from "@marekl/adminer/shell";
import { OfflineBanner } from "@marekl/adminer/components";
import { useAuth } from "../../auth/useAuth";
import { useLogout } from "../../auth/queries";
import { Sidebar } from "../Sidebar";

function MainOutlet() {
  const drawerActions = useShellDrawerActions();
  const location = useLocation();

  useEffect(() => {
    drawerActions?.closeDrawer();
  }, [location.pathname, drawerActions]);

  return <Outlet context={{ currentPath: location.pathname }} />;
}

export function AppLayout() {
  const { user } = useAuth();
  const { mutate: logout } = useLogout();
  const navigate = useNavigate();

  if (!user) return null;

  function handleLogout() {
    logout(undefined, {
      onSettled: () => navigate("/login", { replace: true }),
    });
  }

  return (
    <AppShell
      sidebar={<Sidebar user={user} onLogout={handleLogout} />}
      topbar={<Topbar />}
      toaster={
        <Toaster position="bottom-right" toastOptions={{ duration: 4000 }} />
      }
    >
      <MainOutlet />
      <OfflineBanner />
    </AppShell>
  );
}
